<template>
  <div v-if="platformPermissionsLoaded && checkPermission('learn.insights.courses')">
    <SmartFilters ref="smartFilters" :parent="'gs_courses_insights'"/>
    
    <CRow>
      <CCol col="12" xl="12">
        <CCard class="mb-0">
          <CCardHeader>
            <CRow>
              <CCol cols="4" xl="4" class="pt-0 pb-0 text-left">              
                {{ $t('insights.Overview_courses_followed') }}
              </CCol>
              <CCol cols="8" xl="8" class="pt-0 pb-0 text-xl-right">
                <b-switch class="mb-0 mt-1 mt-xl-0 enable_search" v-model="searchEnabled" size="is-small">{{ $t('common.activate_search') }}</b-switch>
                <div class="mt-1 mt-xl-0 d-inline-block align-top">
                  <CButton class="ml-2 link" color="primary" @click="exportData('csv')">
                    <i class="fas fa-file-arrow-down mr-1"/><span>{{ $t('common.Export_as_csv') }}</span>
                  </CButton>                
                  <CButton class="ml-2 link" color="primary" @click="exportData('json');">
                    <i class="fas fa-file-arrow-down mr-1"/><span>{{ $t('common.Export_as_json') }}</span>              
                  </CButton>
                </div>               
              </CCol>  
            </CRow>
          </CCardHeader>
          <CCardBody class="p-0">
            <div v-if="loadingInsightsData === true">           
              <CRow>
                <CCol cols="12" lg="12">
                  <loadingSpinner mode="auto" :content="null"/>
                </CCol>
              </CRow>
            </div>
            <div v-else>
              <CRow>
                <CCol cols="12" lg="12" class="pb-0 pt-0">                
                  <b-table class="data_table" 
                          :data="coursesFollowed" 
                          :striped="true" 
                          :hoverable="true" 
                          :mobile-cards="true" 
                          :paginated="isPaginated"
                          :per-page="perPage"
                          :current-page.sync="currentPage"
                          :pagination-simple="isPaginationSimple"
                          :pagination-position="paginationPosition" 
                          :default-sort-direction="defaultSortDirection" 
                          :sort-icon="sortIcon" 
                          :sort-icon-size="sortIconSize" 
                          default-sort="Department/Location">
                    
                    <template slot-scope="props">
                      <b-table-column field="employee" :label="$t('common.Employee')" :searchable="searchEnabled" :sortable="true" width="25%">
                        <b>{{props.row.employee}}</b>
                      </b-table-column>
                      <b-table-column field="department" :label="$t('common.Department')" :searchable="searchEnabled" :sortable="true" width="15%">
                        <b>{{props.row.department}}</b>
                      </b-table-column>
                      <b-table-column field="team" :label="$t('common.Team')" :searchable="searchEnabled" :sortable="true" width="15%">
                        {{props.row.team !== null ? props.row.team : '-' }}
                      </b-table-column>                    
                      <b-table-column field="course" :label="$t('common.Course')" :searchable="false" :sortable="true" width="20%">
                        {{props.row.course}}
                      </b-table-column>
                      <b-table-column field="finished" :label="$t('common.Finished')" :searchable="false" :sortable="true" width="12.5%">
                        {{props.row.finished | moment("DD-MM-YYYY HH:mm")}}
                      </b-table-column>
                      <b-table-column field="points" :label="$t('common.Coins')" :searchable="false" :sortable="true" width="12.5%">
                        {{props.row.points}}
                      </b-table-column>
                    </template>
                    <template slot="empty">
                      <div class="p-2 text-center">                      
                        <span>{{ $t('insights.Statistics_not_found') }}</span>
                      </div>                
                    </template>                
                  </b-table>
                </CCol>
              </CRow>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
  <noPermission v-else-if="platformPermissionsLoaded" trigger="permission"/>
</template>

<script>
import axios from 'axios'
import loadingSpinner from '@/components/common/loadingSpinner.vue'
import noPermission from '@/components/common/noPermission.vue';

import SmartFilters from '@/components/insights/common/SmartFilters.vue';

export default {
  name: 'InsightsLearning',
  components: {
    loadingSpinner,
    noPermission,
    SmartFilters
  },
  data: () => {
    return {
      platformPermissions: [],
      platformPermissionsLoaded: false,      
      coursesFollowed: [],
      overviewDataLoaded: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      currentPage: 1,
      perPage: 15,
      searchEnabled: false,
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      showInactive: false,
      searchEnabled: false,
      loadingInsightsData: false,
      smartFilters: []
    }
  },
  methods: {
    getCoursesFollowed () {
      let params = {};
      params.filters = this.smartFilters;
      // Start the loader
      this.loadingInsightsData = true;
      // Get the updates
      axios.post(process.env.VUE_APP_API_URL + '/v1/insights/learn/courses/followed', params)
      .then(res => {
        this.coursesFollowed = res.data.data;
        // Check if the pagination should be activated
        (this.coursesFollowed.length > this.perPage) ? this.isPaginated = true : this.isPaginated = false;        
        // Close the loader
        this.loadingInsightsData = false;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    exportData(outputFormat){
      let params = {};
      params.filters = this.smartFilters;

      axios.post(process.env.VUE_APP_API_URL + '/v1/insights/learn/courses/followed/export/' + outputFormat, params)
      .then(res => {
        this.$buefy.toast.open({ message: this.$t('common.Export_successful'), type: 'is-success', duration: 2000 });
        if (!window.navigator.msSaveOrOpenBlob){
          // Blob navigator
          let url = null;
          let outputData = null;
          // Set the output data and URL based on the output format
          if(outputFormat === 'csv') {
            outputData = res.data;
            url = window.URL.createObjectURL(new Blob([outputData]));  
          } else if(outputFormat === 'json') {
            outputData = JSON.stringify(res.data.data);
            url = window.URL.createObjectURL(new Blob([outputData]));
          }
          // Create a new 'a' element
          const link = document.createElement('a');
          // Set the generated URL as href of the new element
          link.href = url;
          // Set the download attribute based on the output format
          if(outputFormat === 'csv') {
            link.setAttribute('download', 'insights-learning-courses.csv');
          } else if(outputFormat === 'json') {
            link.setAttribute('download', 'insights-learning-courses.json');
          }
          // Append the link to the body
          document.body.appendChild(link);
          // Click the link
          link.click();
        } else {
          // Blob for Explorer 11
          let url = null;
          let outputData = null;
          // Set the output data and URL based on the output format
          if(outputFormat === 'csv') {
            outputData = res.data;
            url = window.navigator.msSaveOrOpenBlob(new Blob([outputData]),"insights-audience-login.csv");
          } else if(outputFormat === 'json') {
            outputData = JSON.stringify(res.data.data);
            url = window.navigator.msSaveOrOpenBlob(new Blob([outputData]),"insights-audience-login.json");
          }
        }
      })
      .catch(err => {
        console.error(err); 
      }); 
    },
    getPlatformPermissions() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/platform/permissions')
      .then(res => {      
        this.platformPermissions = res.data.data;
        // Update the platformPermissionsLoaded value
        this.platformPermissionsLoaded = true;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    checkPermission(permissionTag) {
      if(this.platformPermissions.includes(permissionTag)) {
        return true;
      } else{
        return false;
      }
    }   
  },
  mounted: function() {
    this.getPlatformPermissions();
    this.getCoursesFollowed();

    this.$bus.$on('gs_courses_insights_smart_filters_updated', (filters) => {
      this.smartFilters = filters;
      this.getCoursesFollowed();
    });    
  },
  beforeDestroy() {
    this.$bus.$off('gs_courses_insights_smart_filters_updated');
  }
}
</script>
